// Import and re-export your assets here
export { default as Logo } from './svgs/logo.svg';
export { default as LogoWhite } from './svgs/svgs/keymaster-logo-white.svg';

// Use bundler-managed asset URL so it respects publicPath/homepage after build
export { default as IconClient } from './svgs/icon-km-cliente.png';

export { default as IconArrowUp } from './svgs/svgs/icons/arrow-up.svg';
export { default as IconPlus} from './svgs/svgs/icons/generic-plus.svg';
export { default as IconLocation} from './svgs/svgs/icons/location.svg';
export { default as IconPhone} from './svgs/svgs/icons/phone.svg';
export { default as IconWebsite} from './svgs/svgs/icons/website.svg';
export { default as IconClose} from './svgs/svgs/icons/cross.svg';
export { default as IconSearch} from './svgs/svgs/icons/search.svg';
export { default as IconCheck} from './svgs/svgs/icons/generic-check.svg';
export { default as IconBurguer} from './svgs/svgs/icons/menu-burguer.svg';
export { default as IconEye} from './svgs/svgs/icons/eye-visible.svg';
export { default as IconEyeCut} from './svgs/svgs/icons/eye-not-visible.svg';
export { default as IconArrowLeft} from './svgs/svgs/icons/arrow-left.svg';
export { default as IconUnchecked} from './svgs/svgs/icons/unchecked.svg';
export { default as IconChecked} from './svgs/svgs/icons/checked.svg';
export { default as IconSquareUnchecked} from './svgs/svgs/icons/squareUnchecked.svg';
export { default as IconSquareChecked} from './svgs/svgs/icons/squareChecked.svg';

// Login 
export { default as IconApple} from './svgs/svgs/icons/apple-logo.svg';
export { default as IconGoogle} from './svgs/svgs/icons/google-logo.svg';

export { default as MenuAppAuto } from './svgs/categories/menu-app-auto.svg';

//Help page
export { default as help_step_1} from './images/helpDeleteAccount/help_step_1.png';
export { default as help_step_2} from './images/helpDeleteAccount/help_step_2.png';
export { default as help_step_3} from './images/helpDeleteAccount/help_step_3.png';
export { default as help_step_4} from './images/helpDeleteAccount/help_step_4.png';
export { default as help_step_5} from './images/helpDeleteAccount/help_step_5.png';

export class Assets {
  static vertical = {
    icon: (type: string) => {
      return require(`./verticais/icons/${type || 'DEFAULT'}/iconequip.svg`);
    },
  };
}